import { render } from "./S68373.vue?vue&type=template&id=1dd03588"
const script = {}
script.render = render

export default script